import { FaFilePdf, FaFileVideo } from 'react-icons/fa';
import {
  DocumentTextIcon,
  VideoCameraIcon,
  PhotoIcon,
  SpeakerWaveIcon,
  DocumentIcon,
  DocumentChartBarIcon as XlsxIcon,
  PresentationChartBarIcon as PptxIcon,
  ArchiveBoxIcon as ZipIcon
} from '@heroicons/react/24/outline';

export const getFileIcon = (mimeType, className = "h-5 w-5") => {
  if (!mimeType) return { Component: DocumentTextIcon, className };
  
  const type = mimeType.split('/')[0];
  const subtype = mimeType.split('/')[1];
  
  switch (type) {
    case 'image':
      return { Component: PhotoIcon, className };
    case 'video':
      return { 
        Component: FaFileVideo, 
        className: `${className} text-blue-500`,
        size: 20
      };
    case 'audio':
      return { Component: SpeakerWaveIcon, className };
    case 'application':
      switch(subtype) {
        case 'pdf':
          return { 
            Component: FaFilePdf, 
            className: `${className} text-red-500`,
            size: 20 // Default size for consistency
          };
        case 'msword':
        case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
          return { Component: DocumentIcon, className };
        case 'vnd.ms-excel':
        case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          return { Component: XlsxIcon, className };
        case 'vnd.ms-powerpoint':
        case 'vnd.openxmlformats-officedocument.presentationml.presentation':
          return { Component: PptxIcon, className };
        case 'zip':
        case 'x-rar-compressed':
        case 'x-7z-compressed':
        case 'x-zip-compressed':
          return { Component: ZipIcon, className };
        default:
          return { Component: DocumentIcon, className };
      }
    default:
      return { Component: DocumentIcon, className };
  }
};

export const getFileTypeText = (mimeType) => {
  if (!mimeType) return 'File';
  
  const type = mimeType.split('/')[0];
  const subtype = mimeType.split('/')[1];
  
  switch (type) {
    case 'image':
      return 'Image';
    case 'video':
      return 'Video';
    case 'audio':
      return 'Audio';
    case 'application':
      switch(subtype) {
        case 'pdf':
          return 'PDF';
        case 'msword':
          return 'DOC';
        case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'DOCX';
        case 'vnd.ms-excel':
          return 'XLS';
        case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          return 'XLSX';
        case 'vnd.ms-powerpoint':
          return 'PPT';
        case 'vnd.openxmlformats-officedocument.presentationml.presentation':
          return 'PPTX';
        case 'zip':
        case 'x-rar-compressed':
        case 'x-7z-compressed':
        case 'x-zip-compressed':
          return 'ZIP';
        default:
          return subtype ? subtype.toUpperCase() : 'File';
      }
    default:
      return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'File';
  }
};
